import React from "react";
import "./teaminstructions.css";

import StaticPageHeaders from "../../Components/StaticPageHeaders";
import VideoBanner from "../../Components/TeamWorkout/VideoBanner/VideoBanner";
import Team from "../../Components/Team/Team";
import UnlimitedBannerCom from "../../Components/InstructionsCom/UnlimitedBannerCom";
import Gallery from "../../Components/Home/Gallery/Gallery";
import Sponsors from "../../Components/Home/Sponsers/Sponsers";
import { useNavigate, useSearchParams } from "react-router-dom";
import unlimted_bg from "../../Assets/Images/TeamWorkout/team_work_unlim.png";
import SEO from "../../Components/SEO";

const Teaminstructions = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); // gets id from ?id=5
  const user = JSON.parse(localStorage.getItem("user"));
  let url = ``;
  if (!user || user.role !== "PARENT") {
    localStorage.clear();
    url = `/packages-new/${id}`;
  } else {
    url = `/packages/${id}`;
  }
  return (
    <>
      <SEO
        title="Team Workout - Shootin School Basketball"
        description=""
        url="https://shootinschool.com/team-workout"
      />
      <StaticPageHeaders title="BASKETBALL Team Workouts" />
      <div className="team-page brightness">
        <VideoBanner buttonLink={url} />
        <Team />
        <div className="team-banner team-work">
          {/* <h4>Our coaching staff has helped many different teams take their game to the next level.</h4> */}
        </div>
        {/* <div className="team-banner-2">
        <p>*Sometimes a coach is unaware of exactly what his/her team needs the most. In these cases, we can provide a Team Evaluation and give our opinion on what would be the most effective strategy for the team.</p>
      </div> */}
        <UnlimitedBannerCom />
        <Gallery />
        <Sponsors brValue={1} />
      </div>
    </>
  );
};

export default Teaminstructions;
